


















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class StepTracker extends Vue {
  @Prop({ required: true })
  private total!: number;

  @Prop({ required: true })
  private active!: number;

  // :computed
  private get complete(): number {
    return (this.active / (this.total - 1)) * 100;
  }
}
